import { useEventListener } from '@mantine/hooks'
import { FC, PropsWithChildren, ReactNode, useState } from 'react'
import { PopoverAlign, PopoverPosition, Popover as ReactTinyPopover } from 'react-tiny-popover'
import { ElevationLevelValues } from '../style/tokens'
import { WithClassName } from '../types/utils'
import { Colors } from '../style/colors'
import { Fonts } from '../style/fonts'

export type TooltipProps = WithClassName & {
  title: ReactNode
  align?: PopoverAlign
  positions?: PopoverPosition[]
  reposition?: boolean
  offset?: number
  open?: boolean
  disabled?: boolean
  containerStyle?: Partial<CSSStyleDeclaration>
}

export const Tooltip: FC<PropsWithChildren<TooltipProps>> = ({ className, children, title, align, positions, reposition, offset = 0, open, disabled, containerStyle }) => {
  const [key, setKey] = useState('')
  const [internalOpen, setInternalOpen] = useState(open || false)
  const [previousOpen, setPreviousOpen] = useState(open)

  // `open` drives the tooltip from the parent: realign on change, during render rather than in an effect
  if (previousOpen !== open) {
    setPreviousOpen(open)
    setInternalOpen(open || false)
  }

  const manual = open !== undefined

  const randomKey = () => {
    setKey(`${Math.random()}`)
  }

  useEventListener('resize', randomKey)

  const tooltipContentStyle = {
    background: Colors.Hurricane,
    color: Colors.White,
    padding: '10px',
    borderRadius: '4px',
    ...Fonts.P2,
    maxWidth: '500px',
  }

  return (
    <ReactTinyPopover
      key={key}
      containerStyle={{
        zIndex: `${ElevationLevelValues.high}`,
        ...containerStyle,
      }}
      isOpen={internalOpen}
      content={<div style={tooltipContentStyle}>{title}</div>}
      reposition={reposition ?? false}
      positions={positions || ['top', 'bottom', 'left', 'right']}
      onClickOutside={() => setInternalOpen(false)}
      align={align ?? 'center'}
      padding={offset}
    >
      <div style={{ display: 'inline' }} className={className} onMouseLeave={() => !manual && setInternalOpen(false)} onMouseEnter={() => !disabled && setInternalOpen(true)}>
        {children}
      </div>
    </ReactTinyPopover>
  )
}
